import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [jobId, setJobId] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setJobId(data.job_id);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch { setState("error"); return; }
      if (tries++ < 8) setTimeout(poll, 1800);
      else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-success">
      <div className="max-w-md w-full border border-border rounded-md bg-white p-8 text-center">
        {state === "checking" && (<><Loader2 className="w-10 h-10 animate-spin text-ocean mx-auto mb-4" /><h1 className="font-heading font-bold text-xl text-sapphire">Confirming payment…</h1></>)}
        {state === "paid" && (<>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
          <h1 className="font-heading font-black text-2xl text-sapphire">Payment complete</h1>
          <p className="text-muted-foreground text-sm mt-2">The cleaner has been paid and your platform fee was collected.</p>
          <Button className="bg-ocean hover:bg-ocean/90 mt-6" onClick={() => navigate(jobId ? `/jobs/${jobId}` : "/pm")} data-testid="back-to-job">View Job</Button>
        </>)}
        {(state === "error" || state === "timeout") && (<>
          <XCircle className="w-12 h-12 text-signal mx-auto mb-4" />
          <h1 className="font-heading font-bold text-xl text-sapphire">{state === "timeout" ? "Still processing" : "Payment issue"}</h1>
          <p className="text-muted-foreground text-sm mt-2">{state === "timeout" ? "Payment is taking a moment — check the job shortly." : "We couldn't confirm the payment."}</p>
          <Button variant="outline" className="mt-6" onClick={() => navigate(jobId ? `/jobs/${jobId}` : "/pm")}>Back</Button>
        </>)}
      </div>
    </div>
  );
}
